import { render } from "./PackageForm.vue?vue&type=template&id=349e6076&scoped=true"
import script from "./PackageForm.vue?vue&type=script&lang=js"
export * from "./PackageForm.vue?vue&type=script&lang=js"

import "./PackageForm.vue?vue&type=style&index=0&id=349e6076&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349e6076"]])

export default __exports__